import {GoToCategory} from "../GoToItem";
import {useEmployeeStore} from "../../../api/EmployeeStore";
import {RemoteValue} from "../../../util/RemoteValue";
import {AppPages} from "../../../app-layout/AppPages";
import EmployeeAvatar from "../../employee-avatar/EmployeeAvatar";
import {useGoToItems} from "./useGoToItems";


export function useEmployeeGoToItems(): RemoteValue<GoToCategory> {
    const employees = useEmployeeStore(state => state.remoteValue);

    return useGoToItems(
        'Employees',
        AppPages.employees.requiredPermissions,
        employees,
        employees => employees
            .filter(employee => !employee.deactivated)
            .map(employee => ({
                id: `employee-${employee.id}`,
                label: employee.fullName,
                icon: () => (<EmployeeAvatar employee={employee} sx={{width: 24, height: 24}}/>),
                url: pageUrl => pageUrl(AppPages.employees, {}, {search: employee.fullName}),
            })),
    );
}
